import http from "../http-common";
import authHeader from "../../services/auth-header";

const getAll = (owner) => {
  if (!owner || owner === "undefined") return Promise.resolve({ data: [] });
  return http.get(`/dev/${owner}` , { headers: authHeader() });
};

const get = (id) => {
  return http.get(`/dev/${id}` , { headers: authHeader() });
};

const create = (owner, data) => {
  return http.post(`/dev/${owner}`, data , { headers: authHeader() });
};

const update = (id, data) => {
  return http.put(`/dev/${id}`, data , { headers: authHeader() });
};

const remove = (id) => {
  return http.delete(`/dev/${id}` , { headers: authHeader() });
};

const removeAll = () => {
  return http.delete(`/dev` , { headers: authHeader() });
};

const findByTitle = (title) => {
  return http.get(`/dev?title=${title}` , { headers: authHeader() });
};

const DevService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default DevService;
